import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import "../../css/jobs.css";
import GenericTextArea from "../GenericTextArea";
import { JobQuestionType } from "../../interfaces/jobs";
import { isEmptyOrSpaces } from "../../functions/commons";
import { useSubmitCandidateQuestionAnswersMutation } from "../../store/jobsSlice";
import { useAppSelector } from "../../store/store";
import { isEmpty } from "lodash";

interface JobQuestionsModalPropType {
  jobQuestions: Array<JobQuestionType>;
  jobId: number;
  onCloseModal: Function;
  isApplied: boolean;
  setApplied: Function;
  updateJobStatus: Function;
}

function JobQuestionsModal(props: JobQuestionsModalPropType) {
  const {
    jobQuestions,
    jobId,
    onCloseModal,
    isApplied,
    setApplied,
    updateJobStatus,
  } = props;

  const [qNo, setQuestionNo] = useState<number>(0);
  const [answer, setAnswer] = useState<string>("");
  const [errorAnswer, setErrorAnswer] = useState<string>("");
  const [givenAnswers, setGivenAnswers] = useState<Array<any>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [submitCandidateQuestionAnswers] =
    useSubmitCandidateQuestionAnswersMutation();
  const { user } = useAppSelector((state) => state["user"]);

  const checkIfLastQ = (number: number) => {
    if (number == jobQuestions.length) {
      return jobQuestions.length - 1;
    } else {
      return number + 1;
    }
  };

  const changeBtnText = (number: number) => {
    if (number + 1 == jobQuestions.length) {
      return "Submit & Apply";
    } else {
      return "Next";
    }
  };

  useEffect(() => {
    if (!isEmpty(givenAnswers)) {
      changeBtnSubmit();
    }
  }, [givenAnswers]);

  const changeBtnSubmit = () => {
    if (qNo < jobQuestions.length) {
      if (qNo < jobQuestions.length - 1) {
        setQuestionNo(qNo + 1);
      } else {
        submitAnswersRequest();
      }
    }
  };

  const submitAnswersRequest = async () => {
    setLoading(true);
    const payload = {
      userId: user?.id,
      data: {
        answers: givenAnswers,
        companyJobId: jobId,
        applicationStatus: "Awaiting",
      },
    };

    submitCandidateQuestionAnswers(payload)
      .unwrap()
      .then((testPassed: any) => {
        if (!testPassed) {
          // alert(
          //   "Please make sure you attempt the relevant test for the job in order to apply to this job."
          // );
          setApplied();
          onCloseModal();
        } else {
          updateJobStatus();
          setApplied();
          onCloseModal();
        }
      });
  };

  const onTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setAnswer(e.target.value);
  };

  const errorSec = (err: string) => (
    <div style={{ marginTop: "10px" }}>
      <text style={{ color: "red" }}>{err}</text>
    </div>
  );

  const renderQuestionsContent = () => {
    return (
      <div className="job_modal_container">
        <text>
          Employer has few job specific questions before you proceed further.
        </text>
        <div style={{ textAlign: "center" }}>
          <text>
            {checkIfLastQ(qNo)}/{jobQuestions.length}
          </text>
        </div>
        <div className="job_question_text_container">
          <text>{jobQuestions[qNo]?.question}</text>
        </div>

        <div>
          <GenericTextArea
            text={answer}
            handleOnChange={onTextAreaChange}
            name="answer"
            error={!isEmpty(errorAnswer)}
          />
          {!isEmpty(errorAnswer) && errorSec(errorAnswer)}
        </div>
        <div className="job_question_btn">
          <Button
            loading={loading}
            disabled={loading}
            type="primary"
            htmlType="submit"
            onClick={() => {
              if (isEmptyOrSpaces(answer)) {
                setErrorAnswer("This field cannot be empty");
              } else {
                let answers = [...givenAnswers];
                answers.push({
                  questionId: jobQuestions[qNo]?.id,
                  answer: answer,
                });
                setGivenAnswers(answers);
                setAnswer("");
              }
            }}
          >
            {changeBtnText(qNo)}
          </Button>
        </div>
      </div>
    );
  };
  return (
    <Modal
      footer={null}
      visible={true}
      closable={false}
      className="ant-modal"
      onCancel={(e) => onCloseModal(e)}
    >
      {isApplied ? null : renderQuestionsContent()}
    </Modal>
  );
}
export default JobQuestionsModal;
